import Appointment from './views/appointmentContainer'

export const appointmentRouter = [{
  path: '/add-appointment',
  name: 'add-appointment',
  component: Appointment
}]
